
ADILF.define('streamhub-sdk/collection/clients/write-client',['require','exports','module','lib/streamhub-sdk/src/collection/clients/write-client'],function (require, exports, module) {/*
    Remapped streamhub-sdk/collection/clients/write-client, in support of:
        - 'title'.  One line, line 23.
        - Flagging
        - Feature/Unfeature
*/
'use strict';

var LivefyreWriteClient = require('lib/streamhub-sdk/src/collection/clients/write-client');

LivefyreWriteClient.prototype.trashContent = function (opts, callback) {
    opts = opts || {};
    callback = callback || function () {};
    var url = [
        this._getUrlBase(opts),
        "/api/v3.0/message/",
        opts.contentId,
        "/hide/"
    ].join("");

    var postData = {
        'collection_id': opts.collectionId,
        'site_id': opts.siteId,
        lftoken: opts.lftoken
    };

    this._request({
        method: 'POST',
        url: url,
        data: postData
    }, callback);
};

LivefyreWriteClient.prototype.bozoContent = function (opts, callback) {
    opts = opts || {};
    callback = callback || function () {};
    var url = [
        this._getUrlBase(opts),
        '/api/v3.0/message/',
        opts.contentId,
        '/bozo/'
    ].join("");

    var postData = {
        collection_id: opts.collectionId,
        site_id: opts.siteId,
        lftoken: opts.lftoken
    };

    this._request({
        method: 'POST',
        url: url,
        data: postData
    }, callback);
};

LivefyreWriteClient.prototype.flag = function (opts, callback) {
    opts = opts || {};
    callback = callback || function () {};
    var url = [
        this._getUrlBase(opts),
        '/api/v3.0/message/',
        opts.contentId,
        '/flag/',
        opts.flagType,
        '/'
    ].join("");

    var postData = {
        lftoken: opts.lftoken,
        collection_id:  opts.collectionId
    };

    this._request({
        method: 'POST',
        url: url,
        data: postData
    }, callback);
};

LivefyreWriteClient.prototype.feature = function (opts, callback) {
    opts = opts || {};
    callback = callback || function () {};
    var url = [
        this._getUrlBase(opts),
        '/api/v3.0/collection/',
        opts.collectionId,
        '/feature/',
        opts.contentId,
        '/'
    ].join("");

    var postData = {
        lftoken: opts.lftoken
    };

    this._request({
        method: 'POST',
        url: url,
        data: postData
    }, callback);
};

LivefyreWriteClient.prototype.unfeature = function (opts, callback) {
    opts = opts || {};
    callback = callback || function () {};
    var url = [
        this._getUrlBase(opts),
        '/api/v3.0/collection/',
        opts.collectionId,
        '/unfeature/',
        opts.contentId,
        '/'
    ].join("");

    var postData = {
        lftoken: opts.lftoken
    };

    this._request({
        method: 'POST',
        url: url,
        data: postData
    }, callback);
};

LivefyreWriteClient.prototype.banUser = function (opts, callback) {
    opts = opts || {};
    callback = callback || function () {};

    var url = [
        this._getUrlBase(opts),
        '/api/v3.0/author/',
        opts.authorId,
        '/ban/'
    ].join("");

    var postData = {
        lftoken: opts.lftoken,
        retroactive: opts.retroactive
    };
    // Must include either "network" or "sites" as a param: http://docs.livefyre.com/developers/api-reference/#flex-ban
    if(opts.network) { postData.network = opts.network; }
    if(opts.sites) { postData.sites = opts.sites; }

    this._request({
        method: 'POST',
        url: url,
        data: postData
    }, callback);
};

module.exports = LivefyreWriteClient;
});
